import object from 'helpers/object'


export const initialState = {
  drivers: {
    headings: [
      'Фамилия',
      'Имя',
      'Отчество',
      'Должность',
      'Штатный №',
      '№ бригады',
      '№ автобуса',
      'Статус',
    ],
    values: [],
    pages: 0,
    activePageId: 1,
    limit: 14,
    filterData: {},
    isFetching: true,
  },
  conductors: {
    headings: [
      'Фамилия',
      'Имя',
      'Отчество',
      'Должность',
      'Штатный №',
      'Статус',
    ],
    values: [],
    pages: 0,
    activePageId: 1,
    limit: 14,
    filterData: {},
    isFetching: true,
  },
  buses: {
    headings: [
      'Гос №',
      'Гаражный №',
      'VIN',
      'Марка',
      'Год выпуска',
      'Статус',
    ],
    values: [],
    pages: 0,
    activePageId: 1,
    limit: 14,
    filterData: {},
    isFetching: true,
  },
  routes: {
    headings: [
      'Маршрут',
      'День',
    ],
    values: [],
    pages: 0,
    activePageId: 1,
    limit: 14,
    filterData: {},
    isFetching: true,
  },
}


export const setFetching = (state, payload) =>
  object.setIn(state, [ payload.type, 'isFetching' ], payload.isFetching)

export const setValues = (state, payload) =>
  object.setIn(state, [ payload.type, 'values' ], payload.values)

export const setPages = (state, payload) =>
  object.setIn(state, [ payload.type, 'pages' ], payload.pages)

export const setActivePageId = (state, payload) =>
  object.setIn(state, [ payload.type, 'activePageId' ], payload.activePageId)

export const setFilterData = (state, payload) =>
  object.setIn(state, [ payload.type, 'filterData' ], payload.filterData)
